<template>
  <div id="the-collection">
    <b-container class="the-collection-container">
      <Header title="The Collection" />
      <div class="cards">
        <ProductCard
          :productCardId="1"
          class="collection-card"
          :productData="{
            title: `“FOREVER YOURS” LONG-SLEEVE TEE`,
            subtitle: 'unisex cotton jersey long-sleeve crew neck tee',
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_WHITE-FRONT.jpg'),
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_WHITE-BACK.jpg'),
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_RED-FRONT.jpg'),
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_RED-BACK.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_WHITE-FRONT.jpg'),
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_WHITE-BACK.jpg'),
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_RED-FRONT.jpg'),
              require('@/assets/images/products/whm/LONG-SLEEVE-TEE_FRONT_RED-BACK.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">“FOREVER YOURS” LONG-SLEEVE TEE</h5>
          <div slot="description">
            <p>
              This long-sleeve tee depicts women in various on-field roles and
              evokes the energy and confidence the artist felt after viewing
              photographs of female ballplayers in the All-American Girls
              Professional Baseball League (AAGPBL).
            </p>
            <p>
              Designed in collaboration with Chicago-based artist, Kate Lynn
              Lewis. <br />
              Proceeds benefit Girls in the Game.
            </p>
          </div>
        </ProductCard>
        <ProductCard
          :productCardId="2"
          class="collection-card"
          :productData="{
            title: `“BATTING LASHES” SHORT-SLEEVE TEE`,
            subtitle: 'unisex cotton jersey short-sleeve crew neck tee',
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/whm/SHORT-SLEEVE-TEE_FRONT_BLUE-FRONT.jpg'),
              require('@/assets/images/products/whm/SHORT-SLEEVE-TEE_FRONT_BLUE-BACK.jpg'),
              require('@/assets/images/products/whm/SHORT-SLEEVE-TEE_FRONT_BLACK-FRONT.jpg'),
              require('@/assets/images/products/whm/SHORT-SLEEVE TEE_FRONT_BLACK-BACK.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/whm/SHORT-SLEEVE-TEE_FRONT_BLUE-FRONT.jpg'),
              require('@/assets/images/products/whm/SHORT-SLEEVE-TEE_FRONT_BLUE-BACK.jpg'),
              require('@/assets/images/products/whm/SHORT-SLEEVE-TEE_FRONT_BLACK-FRONT.jpg'),
              require('@/assets/images/products/whm/SHORT-SLEEVE TEE_FRONT_BLACK-BACK.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">“BATTING LASHES” SHORT-SLEEVE TEE</h5>
          <div slot="description">
            <p>
              Traditional baseball cards feature men. This short-sleeve tee puts
              women front and center and makes them the All-Star of the game.
            </p>
            <p>
              Designed in collaboration with Chicago-based artist, Kate Lynn
              Lewis. <br />
              Proceeds benefit Girls in the Game.
            </p>
          </div>
        </ProductCard>
        <ProductCard
          :productCardId="3"
          class="collection-card"
          :productData="{
            title: `“GIRLS IN THE GAME” POSTER`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            subtitle: '18” x 24” screenprint',
            images: [
              require('@/assets/images/products/whm/Girls_In_The_Game_Poster.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/whm/Girls_In_The_Game_Poster.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">“GIRLS IN THE GAME” POSTER</h5>
          <div slot="description">
            <p>
              Representation matters. This 18” x 24” Art Deco-inspired poster is
              a vibrant depiction of what female representation in sports should
              look like in the modern era.
            </p>
            <p>
              (Actual prints may contain slight differences from digital
              rendering.)
            </p>
            <p>
              Designed in collaboration with Chicago-based artist, Kate Lynn
              Lewis. <br />
              Proceeds benefit Girls in the Game.
            </p>
          </div>
        </ProductCard>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/global/Header";
import ProductCard from "@/components/global/ProductCard";
import moment from "moment";

import { mapState } from "vuex";
export default {
  name: "TheCollection",
  data() {
    return {
      moment,
      productAvailable: false,
    };
  },
  components: {
    Header,
    ProductCard,
  },
  computed: {
    ...mapState(["global"]),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#the-collection {
  padding-bottom: 100px;
  @media (max-width: $lg) {
    padding-bottom: 50px;
  }
  @media (max-width: $md) {
    padding-bottom: 0px;
  }
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-collection-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .cards {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 50px;
    @media (max-width: $lg) {
      flex-direction: column;
      align-items: center;
    }
  }
  .collection-card {
    width: 318px;
    max-width: 32.2%;
    @media (max-width: $lg) {
      margin-bottom: 50px;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: $lg) {
      text-align: center;
    }
  }
}
</style>
